import React from 'react';
import DialogContentText from '@material-ui/core/DialogContentText';

import { ButtonPrimary, ButtonPrimaryOutline } from 'components/buttons';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  CloseButton,
  DialogActions,
  Flag,
} from './styledComponents';

const Modal = ({
  isOpen,
  onCancel,
  onConfirmation,
  onDismiss,
  flag,
  title = '',
  content = '',
  confirmButtonText = 'OK',
  cancelButtonText = 'CANCEL',
  ...dialogProps
}) => {
  return (
    <Dialog
      open={isOpen}
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      fullWidth
      onBackdropClick={onCancel || (() => null)}
      {...dialogProps}
    >
      <DialogTitle id="alert-dialog-slide-title">
        {title}
        {onDismiss ? <CloseButton onClick={onDismiss}>×</CloseButton> : null}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          {flag ? <Flag>{flag}</Flag> : null}
          <span dangerouslySetInnerHTML={{ __html: content }}></span>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {onCancel && (
          <ButtonPrimaryOutline onClick={onCancel}>
            {cancelButtonText}
          </ButtonPrimaryOutline>
        )}
        {onConfirmation && (
          <ButtonPrimary onClick={onConfirmation}>
            {confirmButtonText}
          </ButtonPrimary>
        )}
      </DialogActions>
    </Dialog>
  );
};

export { Modal };
